import React from "react"
import { iProgressStateDataItem } from "./index"
import { PieChart, Pie, Cell, Tooltip } from "recharts"

interface iDonutChart {
  data: iProgressStateDataItem[]
  onCellClick: (dataKey: string) => void
}

const CustomToolTip: React.FC<{ active?: any; payload?: any; label?: any }> = ({
  active,
  payload,
  label,
}) => {
  if (!active) return null
  return (
    <div className="bg-white border rounded py-1 px-2 text-site-blue">
      <p className="text-xs">{payload[0].name}</p>
    </div>
  )
}

const DonutChart: React.FC<iDonutChart> = ({ data, onCellClick }) => {
  const getFillColor = (filled: boolean) => {
    if (!filled) return "#a0aec0"
    return "#38a169"
  }

  const pieChartData = data.map(item => ({
    key: item.key,
    name: item.title,
    value: 1,
    color: getFillColor(item.filled),
  }))

  return (
    <PieChart width={200} height={200}>
      <Pie
        data={pieChartData}
        cx={95}
        cy={95}
        innerRadius={35}
        outerRadius={90}
        fill="#8884d8"
        paddingAngle={2}
        dataKey="value"
      >
        {pieChartData.map((entry, index) => (
          <Cell
            onClick={() => onCellClick(entry.key)}
            className="cursor-pointer"
            key={`cell-${index}`}
            fill={entry.color}
          />
        ))}
      </Pie>
      <Tooltip content={<CustomToolTip />} />
    </PieChart>
  )
}

export default DonutChart
